export default "__VITE_ASSET__ad5505a7__"